import React from 'react';
import { IconCalendar } from '@tabler/icons-react';
import { useTranslate } from '@src/core/hooks';
import ProductAdderFooterButtons from '@src/domains/products/features/productAdder/components/ProductAdderFooterButtons';
import { QuantitySelector } from '@src/domains/products/features/product-booking/components/QuantitySelector';
import {
  Container,
  DateLabel,
  DateSummary,
  DateValue,
  FeeNote,
  QuantitySelectorWrapper,
  UnavailableTariffLabel,
} from './styles';
import { usePackageQuantityStep } from './usePackageQuantityStep';

const PackageQuantityStep = ({ isMultiProductFlow = false }: { isMultiProductFlow?: boolean }) => {
  const { i18n } = useTranslate();
  const {
    shouldShowSelectedDate,
    formattedSelectedDate,
    hasDefaultTariff,
    hasAvailableQuantity,
    quantity,
    handleDecrement,
    handleIncrement,
    decrementDisabled,
    incrementDisabled,
  } = usePackageQuantityStep();

  return (
    <>
      <Container>
        {shouldShowSelectedDate && formattedSelectedDate ? (
          <div>
            <DateSummary>
              <IconCalendar size={20} color='#464646' />
              <DateLabel>{i18n('product_package_single_booking_chosen_date')}</DateLabel>
            </DateSummary>

            <DateValue>{formattedSelectedDate}</DateValue>
          </div>
        ) : null}

        <FeeNote>{i18n('product_package_single_booking_additional_fees')}</FeeNote>

        {hasDefaultTariff && hasAvailableQuantity ? (
          <QuantitySelectorWrapper>
            <QuantitySelector
              value={quantity}
              label={i18n('adder_quantity')}
              decrementAriaLabel={i18n('product_booking_quantity_minus')}
              incrementAriaLabel={i18n('product_booking_quantity_plus')}
              onDecrement={handleDecrement}
              onIncrement={handleIncrement}
              decrementDisabled={decrementDisabled}
              incrementDisabled={incrementDisabled}
            />
          </QuantitySelectorWrapper>
        ) : (
          <UnavailableTariffLabel>{i18n('product_package_single_booking_unavailable')}</UnavailableTariffLabel>
        )}
      </Container>
      <ProductAdderFooterButtons isMultiProductFlow={isMultiProductFlow} />
    </>
  );
};

export default PackageQuantityStep;
